export const apiHost = 'https://apibe.panzofi.com';
export const client = 'https://www.panzofi.com';
